// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__8l8pH","rotate":"Spinner_rotate__kgT3c"};